"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteOfNoConfidence = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
const Card_1 = require("../Card");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Turmoil_1 = require("../../turmoil/Turmoil");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class VoteOfNoConfidence extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.VOTE_OF_NO_CONFIDENCE,
            cardType: CardType_1.CardType.EVENT,
            cost: 5,
            tr: { tr: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.partyLeaders()),
            metadata: {
                cardNumber: 'T16',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.minus().chairman().any.asterix();
                    b.nbsp().plus().partyLeaders().br;
                    b.tr(1);
                }),
                description: 'Requires that you have a Party Leader in any party and that the sitting Chairman is neutral. ' +
                    'Remove the NEUTRAL Chairman and move your own delegate (from the reserve) there instead. Gain 1 TR.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (!super.canPlay(player))
            return false;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        if (!turmoil.hasAvailableDelegates(player.id))
            return false;
        const chairmanIsNeutral = turmoil.chairman === 'NEUTRAL';
        if (chairmanIsNeutral === false)
            return false;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        turmoil.delegateReserve.push(turmoil.chairman);
        turmoil.chairman = player.id;
        const index = turmoil.delegateReserve.indexOf(player.id);
        if (index > -1)
            turmoil.delegateReserve.splice(index, 1);
        player.increaseTerraformRatingSteps(1);
        return undefined;
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, TRIncrease: 1 });
    }
}
exports.VoteOfNoConfidence = VoteOfNoConfidence;
//# sourceMappingURL=VoteOfNoConfidence.js.map